<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00058.installation.filtration.titre' | translate"
      [description]="'P00058.installation.filtration.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P00058.installation.filtration.programmeTitre' | translate"
      [information]="openEnSavoirPlus"
      [titleListe]="'P00058.installation.filtration.programme' | translate"
      [description]="
        'P00058.installation.filtration.programmeDescription' | translate
      "
      [value]="actionStack!.getValue('pvCProgrammeAuto')"
      [liste]="P00058ProgrammeFiltrationAuto"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Controle,
          'pvCProgrammeAuto',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (actionStack!.getValue('pvCProgrammeAuto') === 1) {
      <app-two-choices-control
        [title]="'P00058.programme.horlogeHiver' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('pvPTypeHorlogeHiver')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPTypeHorlogeHiver',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('pvPTypeHorlogeHiver') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="
          'P00058.filtration.reglage.descriptionHorloge' | translate
        "
      ></app-label-description>
    }

    @if (actionStack!.getValue('pvCProgrammeAuto') === 0) {
      <app-two-choices-control
        [title]="'P00058.programme.horlogeEte' | translate"
        [firstLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.day'
            | translate
        "
        [firstValue]="0"
        [secondLabel]="
          'P00039.lighting.functionality.parameters.setting.title.clock.week'
            | translate
        "
        [secondValue]="1"
        [value]="actionStack!.getValue('pvPTypeHorlogeEte')"
        (onChange)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPTypeHorlogeEte',
            $event,
            null
          )
        "
      >
      </app-two-choices-control>

      @if (this.actionStack!.getValue('pvPTypeHorlogeEte') === 0) {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingsClockPEEScreen()"
        >
        </app-larged-link>
      } @else {
        <app-larged-link
          [name]="
            'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
              | translate
          "
          (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
        >
        </app-larged-link>
      }

      <app-label-description
        [description]="
          'P00058.filtration.reglage.descriptionEteHorloge' | translate
        "
      ></app-label-description>
    }

    @if (actionStack!.getValue('pvCProgrammeAuto') === 3) {
      <app-label-configuration
        [title]="'P00058.installation.bathing' | translate"
        [titleListe]="'P00058.installation.bathing.timer' | translate"
        [value]="actionStack!.getValue('pvPDureeBaignade')"
        [information]="openEnSavoirPlus2"
        [liste]="getBathingTimer()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPDureeBaignade',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-switch-configuration
      [title]="'P00058.installation.amorcage.title' | translate"
      [nameCustom]="'P00058.installation.amorcage.smallTitle' | translate"
      [value]="actionStack!.getValue('pvIActivationAmorcage') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PompeVS_Installation,
          'pvIActivationAmorcage',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('pvIActivationAmorcage') === 1) {
      <app-label-configuration
        [titleListe]="'P00058.installation.armocagetime' | translate"
        [value]="actionStack!.getValue('pvPDureeAmorcage')"
        [liste]="getAmorcageTimerEnum()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPDureeAmorcage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>

      <app-label-configuration
        [titleListe]="'P00058.installation.armocagespeed' | translate"
        [value]="actionStack!.getValue('pvPVitesseAmorcage')"
        [liste]="getSpeedEnum(35, 100)"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.PompeVS_Parametrage1,
            'pvPVitesseAmorcage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P00058.installation.amorcage.description' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
